

    // Manual quarterly inputs including cap table and startup pro forma projections
// src/constants/investorsDashboard.js

export const manualData_INVESTOR_METRICS = {
  // ← metrics inputs
  currentQuarterRevenue: 250000,
  priorQuarterRevenue: 200000,
  currentMRR: 55000,
  churnRate: 5.2,
  lifetimeValue: 720,
  cac: 150,
  revenue: 1500000,
  costOfGoodsSold: 600000,
  ebitda: 400000,
  cashBalance: 300000,
  monthlyBurn: 75000,

  // ← cap table
  shareholders: [
    { name: "Founder & President", shares: 10000000, classType: "Class B" },
    { name: "Seed Investors",       shares:  3000000, classType: "Preferred" },
    { name: "Employee Pool",        shares:  2000000, classType: "Option" },
  ],
  totalShares: 15000000,

  // ← MRR & churn history
  mrrHistory: [
    { month: "Jan", mrr: 45000, churnRate: 4.5 },
    { month: "Feb", mrr: 46000, churnRate: 4.7 },
    { month: "Mar", mrr: 47000, churnRate: 4.9 },
    { month: "Apr", mrr: 48000, churnRate: 5.1 },
  ],

  // ← pro forma projections
  proForma: [
    {
      year: 2025,
      revenue:                  800000,
      accountsPayable:           60000,
      wagesPayable:             120000,
      travelExpenses:            20000,
      trademarkAttorneyFees:     15000,
      serverlessCost:            18000,
      rdsCost:                   12000,
      hostingCost:                8000,
      ambassadorCost:            25000,
    },
    {
      year: 2026,
      revenue:                 1200000,
      accountsPayable:           80000,
      wagesPayable:             180000,
      travelExpenses:            30000,
      trademarkAttorneyFees:     18000,
      serverlessCost:            24000,
      rdsCost:                   16000,
      hostingCost:               10000,
      ambassadorCost:            35000,
    },
    {
      year: 2027,
      revenue:                 1600000,
      accountsPayable:          100000,
      wagesPayable:             240000,
      travelExpenses:            40000,
      trademarkAttorneyFees:     20000,
      serverlessCost:            30000,
      rdsCost:                   20000,
      hostingCost:               12000,
      ambassadorCost:            45000,
    },
  ],
};
